import { FORMAT_FOCUS_MAX } from '@pulsify/shared/dto'
import { useId } from 'react'
import * as m from '~/paraglide/messages'
import { Label } from '~/shared/ui/label'
import { Textarea } from '~/shared/ui/textarea'

interface FormatFocusFieldProps {
  value: string
  onChange: (value: string) => void
  rows?: number
}

/** What the AI should bring forward when it rearranges an image for a new format. */
export function FormatFocusField({ value, onChange, rows = 2 }: FormatFocusFieldProps) {
  const id = useId()
  return (
    <div className="space-y-1.5">
      <Label htmlFor={id}>{m.formatFocusLabel()}</Label>
      <Textarea
        id={id}
        value={value}
        rows={rows}
        maxLength={FORMAT_FOCUS_MAX}
        placeholder={m.formatFocusPlaceholder()}
        aria-describedby={`${id}-hint`}
        onChange={(event) => onChange(event.target.value)}
      />
      <p id={`${id}-hint`} className="text-muted-foreground text-xs">
        {m.formatFocusHint()}
      </p>
    </div>
  )
}
